import { Grid } from '@mui/material';
import React from 'react';
import { StyledNavbar, Title } from './styles';

const Navbar = React.forwardRef<any, any>(() => (
  <StyledNavbar container>
    <Grid item xs={6}>
      <Title variant="h3">Firearm Licence Portal</Title>
    </Grid>
    <Grid item xs={6} />
  </StyledNavbar>
));

export { Navbar };
